import * as React from "react";
import {WPTable} from "shared/controls/WPTable/WPTable";
import {WPBasicColumn} from "shared/controls/WPTable/Columns/WPBasicColumn";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {WpAjaxPost} from "shared/core/ajax/WPAjaxPost";
import {ConfirmationDialog} from "shared/controls/Dialogs/premade/ConfirmationDialog/ConfirmationDialog";
import {DeleteDialog} from "shared/controls/Dialogs/premade/DeleteDialog";
import {LicenseRequired} from "./LicenseRequired";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {faFileImport} from "@fortawesome/free-solid-svg-icons/faFileImport";
import {ToastService} from "shared/core/services/ToastService";

export class PDFList extends React.Component<PDFListProps, PDFListState> {
    static defaultProps: Partial<PDFListProps> = {};
    public FileInput:HTMLInputElement;
    constructor(props: PDFListProps) {
        super(props);
        this.state = {
            ShowAdd:rnListVar.Text!=''
        };
        WpAjaxPost.SetGlobalVar(rnListVar);
        this.FileRendered=this.FileRendered.bind(this);
    }

    public FileRendered(e)
    {
        this.FileInput=e;
    }

    public render() {
        return (
            <div style={{padding:10}} className={'rednao'}>
                <input style={{display:'none'}} accept={'*.zip'} ref={this.FileRendered} type={'file'} onChange={e=>this.FileSelected(e.target)}/>
                {this.state.ShowAdd&&
                    <div style={{padding:15,backgroundColor:'white',border:'1px solid #dfdfdf',borderRadius:20,marginBottom:10,display:"flex",alignItems:'center',position:'relative'}}>

                        <div style={{position: 'absolute', top: 10, right: 10}}>
                            <a href={'#'} onClick={e=>{e.preventDefault();this.NeverShowAgain()}}>Close and never show again </a>
                            <span style={{margin: '0 5px 0 5px'}}>|</span>
                            <a href={'#'} onClick={e=>{e.preventDefault();this.setState({ShowAdd:false})}}>Close</a>
                        </div>

                        <img src={rnListVar.Icon} style={{width:80,height:80}}/>
                        <div style={{marginLeft:10}}>
                            <p style={{fontSize:18,fontWeight:'bold',margin:0}}>
                                {rnListVar.Text}
                            </p>
                            <a target={'_blank'} href={rnListVar.LinkURL}>{rnListVar.LinkText}</a>
                        </div>
                    </div>
                    }
                <div>
                    <button onClick={e=>this.OpenTemplate(0,e)} style={{display:'inline-flex',alignItems:'center'}} className={'rnbtn rnbtn-success createTemplate'}><FontAwesomeIcon icon={faPlus}/> <span style={{marginLeft:5}}>Create Template</span></button>
                    <button onClick={e=>this.ImportTemplate(0,e)} style={{display:'inline-flex',alignItems:'center',marginLeft:15}} className={'rnbtn rnbtn-primary createTemplate'}><FontAwesomeIcon icon={faFileImport}/> <span style={{marginLeft:5}}>Import Template</span></button>
                </div>
                <WPTable RowClicked={(row,e)=>this.OpenTemplate(row.Id,e)} ActionClicked={(actionId, row,e) => this.ActionClicked(actionId,row,e)} Data={rnListVar.TemplateList} EmptyContent={<p>No template has been created yet, <a href={'#'} onClick={e=>{e.preventDefault();this.OpenTemplate(0,e);}}>Click here to create one</a> </p>}>
                    <WPBasicColumn IsClickable={true}  PropertyName={'Name'} Title={'Template Name'} Actions={[
                        {Title:'Edit',Id:'edit'},
                        {Title:'Delete',Id:'delete'},
                        {Title:'Export',Id:'export'},
                        {Title:'Preview',Id:'preview'}
                    ]}/>
                    <WPBasicColumn PropertyName={'FormName'} Title={'Using form'}/>
                </WPTable>
            </div>
        )
    }

    private OpenTemplate(templateId: number,e:React.MouseEvent<any>) {
        e.preventDefault();
        if(templateId==0&& rnListVar.IsPR==''&&rnListVar.TemplateList.length>=1)
        {
            Dialog.Show(<LicenseRequired Message={'Sorry you can only create one template in the free version'}  URL={rnListVar.PurchaseURL}/>)
            return;
        }


        let url=rnListVar.TemplateURL+'&templateId='+templateId;
        if(e.shiftKey||e.ctrlKey)
            window.open(url);
        else
            window.location.href=url;

    }

    private ActionClicked(actionId: string, row: any,e:any) {
        switch (actionId)
        {
            case 'edit':
                this.OpenTemplate(row.Id,e);
                break;
            case 'delete':
                DeleteDialog.Show(row.Name,'Are you sure?',async () => {
                    let result=await WpAjaxPost.Post('Delete',{TemplateId:row.Id});
                    if(result!=null)
                    {
                        rnListVar.TemplateList.splice(rnListVar.TemplateList.indexOf(row),1);
                        this.forceUpdate();
                    }
                    return result!=null;
                })
                break;
            case 'preview':
                this.Preview(row.Id);
                break;
            case 'export':
                this.Export(row.Id);
        }
    }
    private Export(Id: any) {
        let form=document.createElement('form');
        document.body.appendChild(form);
        form.style.display='none';
        form.action=rnListVar.ajaxurl;
        form.method='post';
        form.target='_blank';

        let action=document.createElement('input');
        action.type='hidden';
        action.value=rnListVar._prefix+'_'+'Export';
        action.name='action';
        form.appendChild(action);

        let templateId=document.createElement('input');
        templateId.type='hidden';
        templateId.value=Id;
        templateId.name='templateId'
        form.appendChild(templateId);

        let nonce=document.createElement('input');
        nonce.type='hidden';
        nonce.value=rnListVar._nonce;
        nonce.name='_nonce'
        form.appendChild(nonce);


        form.submit();
    }

    private Preview(Id: any) {
        let form=document.createElement('form');
        document.body.appendChild(form);
        form.style.display='none';
        form.action=rnListVar.ajaxurl;
        form.method='post';
        form.target='_blank';

        let action=document.createElement('input');
        action.type='hidden';
        action.value=rnListVar._prefix+'_'+'Preview';
        action.name='action';
        form.appendChild(action);

        let templateId=document.createElement('input');
        templateId.type='hidden';
        templateId.value=Id;
        templateId.name='templateId'
        form.appendChild(templateId);

        let nonce=document.createElement('input');
        nonce.type='hidden';
        nonce.value=rnListVar._nonce;
        nonce.name='_nonce'
        form.appendChild(nonce);


        form.submit();
    }

    private NeverShowAgain() {
        this.setState({ShowAdd:false});
        WpAjaxPost.Post('NeverShowAgain');
    }

    private ImportTemplate(number: number, e: React.MouseEvent<HTMLButtonElement>) {
        if(rnListVar.IsPR==''&&rnListVar.TemplateList.length>=1) {
            Dialog.Show(<LicenseRequired Message={'Sorry you can only create one template in the free version'}
                                         URL={rnListVar.PurchaseURL}/>)
            return;
        }
        this.FileInput.click();
    }

    private async FileSelected(target: EventTarget & HTMLInputElement) {
        if(target.files.length==0)
            return;


        ToastService.SendSuccess('Importing template...');

        let result=await WpAjaxPost.Post('Import',{},null,{file:target.files[0]});
        target.value='';
        if(result!=null)
            ToastService.SendSuccess('Template imported successfully, the page will be reloaded');

        setTimeout(()=>window.location.reload(),3000)

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface PDFListProps {

}

interface PDFListState {
    ShowAdd:boolean;
}

//#endregion "My Region"